const state = {
  reviewTagTypes: [],
  isLoadingReviewTagTypes: true
};

const mutations = {
  SET_REVIEW_TAG_TYPES(state, reviewTagTypes) {
    state.reviewTagTypes = reviewTagTypes;
  },
  SET_IS_LOADING_REVIEW_TAG_TYPES(state, isLoadingReviewTagTypes) {
    state.isLoadingReviewTagTypes = isLoadingReviewTagTypes;
  }
};

const actions = {
  fetchReviewTagTypes({ commit, rootState }) {
    const product_code = rootState.productCode;
    commit('SET_IS_LOADING_REVIEW_TAG_TYPES', true);
    rootState.api
      .fetchReviewTagTypes(product_code)
      .then(({ data }) => {
        commit('SET_REVIEW_TAG_TYPES', data.review_tag_types);
      })
      .finally(() => commit('SET_IS_LOADING_REVIEW_TAG_TYPES', false));
  }
};

export default { namespaced: true, state, mutations, actions };
